import {FC} from 'react'
import {StateEditModalForm} from './StateEditModalForm'
import {StateEditModalHeader} from './StateEditModalHeader'
import {State} from '../core/_models'
import {useListView} from '../core/ListViewProvider'

type Props = {
  state: State
  isStateLoading: boolean
}

const StateEditModal: FC<Props> = ({state, isStateLoading}) => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const isOpen = itemIdForUpdate === state.id

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <StateEditModalHeader />
            <div className='modal-body scroll-y mx-5 my-7'>
              <StateEditModalForm state={state} isStateLoading={isStateLoading} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {StateEditModal}
